import {
  GET_OUT_RIGHT_LOST_COUPONS_REQUEST,
  GET_OUT_RIGHT_LOST_COUPONS_SUCCESS,
  GET_OUT_RIGHT_LOST_COUPONS_FAILURE,
  RESET_OUT_RIGHT_LOST_PAGINATION
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    pageSize: 10,
    pageIndex: 0,
    isLoadMoreButtonVisible: false
  },
  isFetched: false,
  isLoading: null,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_OUT_RIGHT_LOST_COUPONS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_OUT_RIGHT_LOST_COUPONS_SUCCESS:

      if (action.couponDetail) {
        state.data.map(coupon => {
          if (coupon.couponId === action.couponDetail.couponId) {
            return coupon['selections'] = action.couponDetail['couponColumns'];
          }
          return coupon;
        });
      }
      
      return {
        data: action.couponDetail ? [...state.data, ...action.payload] : action.payload,
        isFetched: true,
        isLoading: false,
        error: null
      };
    case GET_OUT_RIGHT_LOST_COUPONS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_OUT_RIGHT_LOST_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };
    default:
      return state;
  }
};
